import * as babelPolyfill from 'babel-polyfill';

import { module } from './app';

import config from './config';
import stateConfig from './stateConfig';

import * as controllers from './controllers';
import * as directives from './directives';
import * as filters from './filters';
import * as services from './domains';
import * as models from './models';
import * as domains from './services';


import {upgradeTechpad, pubsubService, ChatModuleConfiguration} from '@magview/techpad-upgrade-module';

require('../styles/main.scss');

function onDeviceReady() {
  upgradeTechpad(module.name);
  window.pubsubService = pubsubService;

  ChatModuleConfiguration.chatPageUrl = '#/root/conversations';
  ChatModuleConfiguration.notificationSoundUrl = '/sounds/notification.mp3';
}

onDeviceReady();


// WEBPACK FOOTER //
// ./src/scripts/main.js